var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_52815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 7.5C12.6875 9.00842 12.0883 10.4551 11.0217 11.5217C9.95506 12.5883 8.50842 13.1875 7 13.1875C5.49158 13.1875 4.04494 12.5883 2.97833 11.5217C1.91172 10.4551 1.3125 9.00842 1.3125 7.5C1.3125 5.99158 1.91172 4.54494 2.97833 3.47833C4.04494 2.41172 5.49158 1.8125 7 1.8125C8.50842 1.8125 9.95506 2.41172 11.0217 3.47833C12.0883 4.54494 12.6875 5.99158 12.6875 7.5ZM0 7.5C0 9.35652 0.737498 11.137 2.05025 12.4497C3.36301 13.7625 5.14348 14.5 7 14.5C8.85652 14.5 10.637 13.7625 11.9497 12.4497C13.2625 11.137 14 9.35652 14 7.5C14 5.64348 13.2625 3.86301 11.9497 2.55025C10.637 1.2375 8.85652 0.5 7 0.5C5.14348 0.5 3.36301 1.2375 2.05025 2.55025C0.737498 3.86301 0 5.64348 0 7.5ZM6.34375 3.78125V7.5C6.34375 7.71875 6.45312 7.92383 6.63633 8.04688L9.26133 9.79688C9.56211 9.99922 9.96953 9.91719 10.1719 9.61367C10.3742 9.31016 10.2922 8.90547 9.98867 8.70312L7.65625 7.15V3.78125C7.65625 3.41758 7.36367 3.125 7 3.125C6.63633 3.125 6.34375 3.41758 6.34375 3.78125Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_52815"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H14V14.5H0V0.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmTime);
export default __webpack_public_path__ + "static/media/sm-time.323b3867b90f6990928ae09b169c15b9.svg";
export { ForwardRef as ReactComponent };